/**
 * Mock Academic Years and Terms
 */

import type { CpAcademicYear, CpTerm } from '../../../types/curriculum_planning';

const now = Date.now();

export const mockCpAcademicYears: CpAcademicYear[] = [
  {
    id: 'ay-2024-2025',
    name: '2024-2025',
    startDate: '2024-09-02',
    endDate: '2025-07-18',
    isActive: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'ay-2025-2026',
    name: '2025-2026',
    startDate: '2025-09-01',
    endDate: '2026-07-17',
    isActive: false,
    createdAt: now,
    updatedAt: now,
  },
];

export const mockCpTerms: CpTerm[] = [
  // 2024-2025 Terms
  {
    id: 'term-2024-1',
    academicYearId: 'ay-2024-2025',
    name: 'Autumn Term',
    termNumber: 1,
    startDate: '2024-09-02',
    endDate: '2024-12-20',
    createdAt: now,
  },
  {
    id: 'term-2024-2',
    academicYearId: 'ay-2024-2025',
    name: 'Spring Term',
    termNumber: 2,
    startDate: '2025-01-06',
    endDate: '2025-04-11',
    createdAt: now,
  },
  {
    id: 'term-2024-3',
    academicYearId: 'ay-2024-2025',
    name: 'Summer Term',
    termNumber: 3,
    startDate: '2025-04-28',
    endDate: '2025-07-18',
    createdAt: now,
  },
  // 2025-2026 Terms
  {
    id: 'term-2025-1',
    academicYearId: 'ay-2025-2026',
    name: 'Autumn Term',
    termNumber: 1,
    startDate: '2025-09-01',
    endDate: '2025-12-19',
    createdAt: now,
  },
  {
    id: 'term-2025-2',
    academicYearId: 'ay-2025-2026',
    name: 'Spring Term',
    termNumber: 2,
    startDate: '2026-01-05',
    endDate: '2026-04-10',
    createdAt: now,
  },
  {
    id: 'term-2025-3',
    academicYearId: 'ay-2025-2026',
    name: 'Summer Term',
    termNumber: 3,
    startDate: '2026-04-27',
    endDate: '2026-07-17',
    createdAt: now,
  },
];
